import { contentBreakpoints, screensMax, screensMin } from '../tokens'
import type { ColorFamily, Colors } from '../tokens/colors'
import type { Columns } from '../tokens/contentBreakpoints'
import type { Dimensions } from '../tokens/dimensions'
import contract from './contract.vanilla.css'
import legacySystem from './legacy/legacySystem.vanilla.css'

export { type Dimensions, type ColorFamily, type Colors, type Columns }

const theme = {
  ...contract,
  ...legacySystem,
  colors: {
    ...contract.colors,
    ...legacySystem.colors,
  },
  borderRadius: {
    ...contract.borderRadius,
    ...legacySystem.borderRadius,
  },
  contentBreakpoints,
  screensMin,
  screensMax,
}

export default theme
